module.exports = __webpack_public_path__ + "img/selected7-min.db35ce4d.png";